import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  Container,
  Row,
  Col,
  Image,
  Card,
  Button,
  Alert,
} from "react-bootstrap";
import ReactPlayer from "react-player";
import { withTranslation } from "react-i18next";

import LoginBox from "./LoginBox";
import PopUp from "./PopUp";
import ContactForm from "./ContactForm";
import FullSection from "./FullSection";
import i18n from "../constants/i18n";
import Arrow from "./Arrow/Arrow";
import OrthoImage2 from "../assets/ortho_models/2.png";
import OrthoImage3 from "../assets/ortho_models/3.png";
import OrthoImage5 from "../assets/ortho_models/5.jpg";
import OrthoImage5Popup from "../assets/ortho_models/5popup.jpg";
import OrthoImage6 from "../assets/ortho_models/6.jpg";
import OrthoImage6Popup from "../assets/ortho_models/6popup.jpg";
import OrthoImage7 from "../assets/ortho_models/7.jpg";
import OrthoImage7Popup from "../assets/ortho_models/7popup.jpg";
import OrthoImage8 from "../assets/ortho_models/8.jpg";
import OrthoImage9 from "../assets/ortho_models/9.jpg";
import OrthoImage10 from "../assets/ortho_models/10.jpg";
import OrthoImage11 from "../assets/ortho_models/11.jpg";
import OrthoImage12 from "../assets/ortho_models/12.jpg";
import OrthoImage13 from "../assets/ortho_models/13.jpg";
import OrthoImage14 from "../assets/ortho_models/14.jpg";
import OrthoImage15 from "../assets/ortho_models/15.jpg";
import OrthoImage16 from "../assets/ortho_models/16.jpg";
import OrthoImage17 from "../assets/ortho_models/17.jpg";
import OrthoImage18 from "../assets/ortho_models/18.jpg";
import OrthoImage19 from "../assets/ortho_models/19.jpg";
import OrthoImage20 from "../assets/ortho_models/20.jpg";
import OrthoImage21 from "../assets/ortho_models/21.jpg";
import OrthoImage22 from "../assets/ortho_models/22.jpg";

import OrthoImage24 from "../assets/ortho_models/24.jpg";
import OrthoImage24Popup from "../assets/ortho_models/24popup.jpg";
import OrthoImage25 from "../assets/ortho_models/25.png";
import OrthoImage26 from "../assets/ortho_models/26.jpg";
import OrthoImage26Popup from "../assets/ortho_models/26popup.jpg";
import OrthoImage27 from "../assets/ortho_models/27.jpg";
import OrthoImage27Popup from "../assets/ortho_models/27popup.jpg";
import OrthoImage28 from "../assets/ortho_models/28.jpg";
import OrthoImage29 from "../assets/ortho_models/29.jpg";
import OrthoImage30 from "../assets/ortho_models/30.jpg";
import OrthoImage31 from "../assets/ortho_logos/ipa.jpg";
import OrthoImage32 from "../assets/ortho_logos/aligner.jpg";
import OrthoImage32pl from "../assets/ortho_logos/aligner_pl.png";
import OrthoImage32BQ from "../assets/ortho_logos/alignerBQ.png";
import OrthoImage33 from "../assets/ortho_models/33.PNG";
import OrthoImage34 from "../assets/ortho_models/34.jpg";
import OrthoImage35 from "../assets/ortho_models/35.PNG";
import OrthoImage37 from "../assets/ortho_models/37.jpg";
import Play from "../assets/ortho_logos/play.png";

import DDPOrtho from "../assets/ddp_ortho/1.png";
import DDSPro from "../assets/dds_pro/1.png";
import Ortonet from "../assets/ortonet/2.png";
import Helo from "../assets/helo/helo.png";
import Helo1 from "../assets/helo/helo1.png";
import Helo2 from "../assets/helo/helo2.png";
import Helo3 from "../assets/helo/helo3.png";
import Ortonet1 from "../assets/ortonet/1.png";
import DTS from "../assets/dts/1.png";
import Footer from "./Footer";
import GoToTopArrow from "./GoToTopArrow";

import IPA_PL from "../assets/ortho_logos/IPA_PL.png";
import IPA_EN from "../assets/ortho_logos/IPA_EN.png";

import Polorto from "../assets/ortho_logos/logo_en.png";
import PolortoPL from "../assets/ortho_logos/logo_pl.png";

import OrtoLab from "../assets/ortho_logos/ortolab.png";

import { LanguageFlag } from "./LanguageFlag";
import { useLocation } from "react-router-dom";

const MainPage = (props) => {
  const location = useLocation();

  const customDTSHeight = 13;
  const ddsProRef = useRef(null);
  const ortonetRef = useRef(null);
  const ortoModelsRef = useRef(null);
  const ddpOrthoRef = useRef(null);
  const dtsRef = useRef(null);
  const ipaRef = useRef(null);
  const heloRef = useRef(null);
  const alignerRef = useRef(null);
  const goToPlace = (place) => {
    if (place == "top") {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: place.current.offsetTop - 20,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    document.title = "DDP SYSTEMS";
  }, []);

  useEffect(() => {
    tryToMatchLanguage(location);
  }, [location]);

  const tryToMatchLanguage = (location) => {
    try {
      let tempLang = location.pathname;
      tempLang = tempLang?.match(/[a-zA-Z]/g)?.join("");

      if (tempLang == "pl" || tempLang == "en") {
        setFlag(tempLang);
        i18n.changeLanguage(tempLang, () => {});
      }
    } catch (e) {}
  };

  const [numberOfTopCardsColumns, setNumberOfTopCardsColumns] = useState(() => {
    if (window.innerWidth >= 990 && window.innerWidth <= 1700) {
      return 11;
    } else {
      return 7;
    }
  });

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 990 && window.innerWidth <= 1700) {
        setNumberOfTopCardsColumns(11);
      } else {
        setNumberOfTopCardsColumns(7);
      }
    }

    if (window.location.hash === "#dds")
      setTimeout(() => {
        goToPlace(ddsProRef);
      }, 200);
    if (window.location.hash === "#ortonet")
      setTimeout(() => {
        goToPlace(ortonetRef);
      }, 200);
    if (window.location.hash === "#aligner")
      setTimeout(() => {
        goToPlace(alignerRef);
      }, 200);
    if (window.location.hash === "#ortomodels")
      setTimeout(() => {
        goToPlace(ortoModelsRef);
      }, 200);
    if (window.location.hash === "#ipa")
      setTimeout(() => {
        goToPlace(ipaRef);
      }, 200);
    if (window.location.hash === "#ddp")
      setTimeout(() => {
        goToPlace(ddpOrthoRef);
      }, 200);
    if (window.location.hash === "#dts")
      setTimeout(() => {
        goToPlace(dtsRef);
      }, 200);
    if (window.location.hash === "#helo")
      setTimeout(() => {
        goToPlace(heloRef);
      }, 200);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [location]);

  const [openContactPopUp, setOpenContactPopUp] = useState(false);

  const [openVideo1PopUp, setOpenVideo1PopUp] = useState(false);
  const [openVideo2PopUp, setOpenVideo2PopUp] = useState(false);
  const [openVideo3PopUp, setOpenVideo3PopUp] = useState(false);
  const [openVideo4PopUp, setOpenVideo4PopUp] = useState(false);
  const [openVideo5PopUp, setOpenVideo5PopUp] = useState(false);

  const [openPicture1PopUp, setOpenPicture1PopUp] = useState(false);
  const [openPicture2PopUp, setOpenPicture2PopUp] = useState(false);
  const [openPicture3PopUp, setOpenPicture3PopUp] = useState(false);
  const [openPicture4PopUp, setOpenPicture4PopUp] = useState(false);
  const [openPicture5PopUp, setOpenPicture5PopUp] = useState(false);
  const [openPicture6PopUp, setOpenPicture6PopUp] = useState(false);
  const [openPicture7PopUp, setOpenPicture7PopUp] = useState(false);
  const [openPicture8PopUp, setOpenPicture8PopUp] = useState(false);
  const [openPicture9PopUp, setOpenPicture9PopUp] = useState(false);
  const [openPicture10PopUp, setOpenPicture10PopUp] = useState(false);
  const [openPicture11PopUp, setOpenPicture11PopUp] = useState(false);
  const [openPicture12PopUp, setOpenPicture12PopUp] = useState(false);
  const [openPicture13PopUp, setOpenPicture13PopUp] = useState(false);
  const [openPicture14PopUp, setOpenPicture14PopUp] = useState(false);
  const [openPicture15PopUp, setOpenPicture15PopUp] = useState(false);
  const [openPicture16PopUp, setOpenPicture16PopUp] = useState(false);
  const [openPicture17PopUp, setOpenPicture17PopUp] = useState(false);
  const [openPicture18PopUp, setOpenPicture18PopUp] = useState(false);
  const [openPicture19PopUp, setOpenPicture19PopUp] = useState(false);
  const [openPicture20PopUp, setOpenPicture20PopUp] = useState(false);
  const [openPicture21PopUp, setOpenPicture21PopUp] = useState(false);
  const [openPicture22PopUp, setOpenPicture22PopUp] = useState(false);
  const [openPicture23PopUp, setOpenPicture23PopUp] = useState(false);
  const [openPicture24PopUp, setOpenPicture24PopUp] = useState(false);
  const [openPicture25PopUp, setOpenPicture25PopUp] = useState(false);
  const [openPicture26PopUp, setOpenPicture26PopUp] = useState(false);

  const [flag, setFlag] = useState("en");

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap"
        rel="stylesheet"
      ></link>
      <FullSection pageStyle={"FirstPage"}>
        <LanguageFlag i18n={i18n} flag={flag} outsideFlagSetter={setFlag} />
        <Container
          className="FirstPageContainer"
          fluid
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            minHeight: "90vh",
            paddingRight: "0px", // przesunięcie pierwszej strony w prawo
          }}
        >
          <Row
            className="TopCardsHolder2"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col
              fluid
              xs={12}
              md={9}
              lg={numberOfTopCardsColumns}
              className="TopCardsHolder mt-md-5 mt-sm-5 mt-xs-5 col-lg-6"
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Row>
                <Col
                  xs={12}
                  lg={5}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3 "
                >
                  <Card
                    className="TopCards"
                    style={{ display: "flex", textAlign: "center" }}
                    onClick={() => goToPlace(ddsProRef)}
                  >
                    <div className="CardImage CardImageWithPadding">
                      <Image src={DDSPro} alt="Card image" fluid />
                    </div>
                    <div className="TopCardTextBox">
                      <h3 className="PaddingBottmHeader">
                        <b>DDS-Pro</b>
                      </h3>
                      <div class="TopCardTextSpacer">
                        <span className="TopCardSpanText">
                          {i18n.t("st3_0")} <br />
                          <b>{i18n.t("st3_1")} </b>
                          <br />
                          {i18n.t("st3_2")} <br />
                          {i18n.t("st3_3")}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={12} lg={7} className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3">
                  <Card
                    pointerEvents={"none"}
                    className="TopCards"
                    style={{
                      display: "flex",
                      position: "relative",
                      textAlign: "center",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      paddingTop: "1.5rem",
                    }}
                  >
                    <div
                      className="TopCardTextBox"
                      style={{
                        position: "relative",
                        flex: 1,
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <div className={"TopCardImageSpacer"}>
                        <Image
                          fluid
                          className="TopCardsOrto"
                          src={Ortonet}
                          rounded
                        />
                      </div>

                      <p className="TopCardSlimText">
                        <b>
                          {i18n.t("st4_0")}
                          <br />
                          {i18n.t("st4_1")}
                        </b>
                        <br />
                        {i18n.t("st4_2")}
                        <br />
                        {i18n.t("st4_3")}
                        <br />
                        {i18n.t("st4_4")}
                        <br />
                        {i18n.t("st4_5")}
                      </p>
                    </div>
                    <div
                      className="TopCardTextBox"
                      style={{
                        position: "relative",
                        flex: 1,
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <div className={"TopCardImageSpacer"}>
                        <Image
                          fluid
                          className="TopCardsHelo"
                          src={Helo}
                          rounded
                        />
                      </div>
                      <p className="TopCardSlimText">
                        <b>{i18n.t("st8_0")} </b>
                        <br />
                        {i18n.t("st8_1")} <br />
                        {i18n.t("st8_2")} <br />
                        {i18n.t("st8_3")}
                      </p>
                    </div>
                  </Card>
                  <div
                    onClick={(e) => goToPlace(heloRef)}
                    style={{
                      display: "flex",
                      flex: 1,
                      height: "100%",
                      width: "45%",
                      position: "absolute",
                      cursor: "pointer",
                      top: 0,
                      right: 0,
                    }}
                  />
                  <div
                    onClick={(e) => goToPlace(ortonetRef)}
                    style={{
                      display: "flex",
                      flex: 1,
                      height: "100%",
                      width: "45%",
                      position: "absolute",
                      cursor: "pointer",
                      top: 0,
                      left: 0,
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={3} className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3">
                  <Card
                    className="TopCards"
                    style={{
                      display: "flex",
                      textAlign: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                    onClick={() => goToPlace(alignerRef)}
                  >
                    <Row className="pb-3">
                      <Image
                        fluid
                        className="TopCardsAlignerAndIpa"
                        style={{ paddingRight: "2rem", paddingLeft: "2rem" }}
                        src={flag === "pl" ? OrthoImage32pl : OrthoImage32BQ}
                        rounded
                      />
                    </Row>
                    <Row>
                      <div class="TopCardTextSpacer">
                        <span
                          className="TopCardSpanText "
                          style={{ textAlign: "center" }}
                        >
                          <b>{i18n.t("st7_0")} </b>
                          <br />
                          {i18n.t("st7_1")} <br />
                          {i18n.t("st7_2")} <br />
                          {i18n.t("st7_3")} <br />
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>

                <Col xs={12} lg={6} className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3">
                  <Card
                    className="TopCards"
                    style={{ display: "flex", textAlign: "center" }}
                    onClick={() => goToPlace(ortoModelsRef)}
                  >
                    <div className="CardImageOld">
                      <Image src={OrthoImage3} alt="Card image" />
                    </div>
                    <div className="TopCardTextBox">
                      <h3 className="PaddingBottmHeader">
                        <b>{i18n.t("st1_0_title_1")}</b> <br />
                        <b>{i18n.t("st1_0_title_2")}</b>
                      </h3>
                      <div class="TopCardTextSpacer">
                        <span className="TopCardSpanText">
                          <b>{i18n.t("st1_0")} </b>
                          <br />
                          {i18n.t("st1_1")} <br />
                          {i18n.t("st1_2")}
                          {i18n.t("st1_3")}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={12} lg={3} className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3">
                  <Card
                    className="TopCards"
                    style={{
                      display: "flex",
                      textAlign: "center",
                      alignItems: "center",
                    }}
                    onClick={() => goToPlace(ipaRef)}
                  >
                    <Row className="pb-3">
                      <Image
                        fluid
                        className="TopCardsAlignerAndIpa"
                        style={{ paddingRight: "2rem", paddingLeft: "2rem" }}
                        src={flag == "en" ? IPA_EN : IPA_PL}
                        rounded
                      />
                    </Row>
                    <Row>
                      <div class="TopCardTextSpacer">
                        <span
                          className="TopCardSpanText "
                          style={{
                            textAlign: "center",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {i18n.t("st6_0")}
                          <b>{i18n.t("st6_1")}</b> {/*<br />*/}
                          <b>{i18n.t("st6_2")} </b>
                          {i18n.t("st6_3")} <br />
                          {i18n.t("st6_4")}
                          <br />
                          {i18n.t("st6_5")}
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6} className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3">
                  <Card
                    className="TopCards"
                    style={{ display: "flex", textAlign: "center" }}
                    onClick={() => goToPlace(ddpOrthoRef)}
                  >
                    <div className="CardImage CardImageWithPadding">
                      <Image src={DDPOrtho} alt="Card image" fluid />
                    </div>
                    <div className="TopCardTextBox">
                      <h3 className="PaddingBottmHeader">
                        <b>DDP-Ortho</b>
                      </h3>
                      <div class="TopCardTextSpacer">
                        <span className="TopCardSpanText">
                          {i18n.t("st2_0")} <br />
                          <b>{i18n.t("st2_1")} </b>
                          <br />
                          {i18n.t("st2_2")} <br />
                          {i18n.t("st2_3")}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={12} lg={6} className="mb-xs-3 mb-sm-3 mb-md-3 mb-lg-3">
                  <Card
                    className="TopCards"
                    style={{ display: "flex", textAlign: "center" }}
                    onClick={() => goToPlace(dtsRef)}
                  >
                    <div className="CardImage CardImageWithPadding">
                      <Image src={DTS} alt="Card image" fluid />
                    </div>
                    <div style={{ pointerEvents: "none" }}>
                      <h3 className="PaddingBottmHeader">
                        <b>DTS</b>
                      </h3>
                      <div class="TopCardTextSpacer">
                        <span className="TopCardSpanText">
                          {i18n.t("st5_0")} <br />
                          <b>{i18n.t("st5_1")} </b>
                          <br />
                          {i18n.t("st5_2")} <br />
                          {i18n.t("st5_3")}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Col>

            <Col
              xs={12}
              md={9}
              lg={3}
              className="p-lg-5"
              // className="offset-lg-1"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <h2 className="text-center" style={{ color: "white" }}>
                {i18n.t("title0_1")}
              </h2>
              <h2 className="text-center mb-5" style={{ color: "white" }}>
                {i18n.t("title0_2")} <b>{i18n.t("title0_3")}</b>
              </h2>
              <LoginBox />
              <h5 className="text-center mt-5" style={{ color: "white" }}>
                {i18n.t("checkOurOffer0_1")}{" "}
                <b style={{ color: "white" }}>{i18n.t("checkOurOffer0_2")}</b>
                {i18n.t("checkOurOffer0_3")}
              </h5>

              <Button
                onClick={() => {
                  setOpenContactPopUp(true);
                }}
                block
                className="mt-5"
                variant="outline-primary"
                style={{
                  minWidth: "5rem",
                  maxWidth: "10rem",
                  height: "3rem",
                  backgroundColor: "white",
                }}
              >
                {i18n.t("ContactUs")}
              </Button>
              <PopUp
                modalSize="lg"
                modalStyle="ContactModal"
                showPopUp={openContactPopUp}
                setShowPopUp={setOpenContactPopUp}
              >
                <ContactForm
                  closeClicked={() => {
                    setOpenContactPopUp(false);
                  }}
                />
              </PopUp>
              <Row
                style={{
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  marginTop: "5rem",
                }}
              >
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    marginBottom: "1rem",
                    backgroundColor: "white",
                    borderRadius: "0.3rem",
                    paddingBottom: "1rem",
                    paddingTop: "1rem",
                    minWidth: "20rem",
                  }}
                >
                  <Image
                    className={"Polorto"}
                    src={flag === "pl" ? PolortoPL : Polorto}
                    alt="Polorto image"
                    onClick={() => {
                      window.open(
                        flag === "pl"
                          ? "https://polorto.com.pl/"
                          : "https://polorto.com.pl/en/doctors/",
                        "_blank"
                      );
                    }}
                  />
                  <Image
                    className={"Ortolab"}
                    style={{ marginTop: "1rem" }}
                    src={OrtoLab}
                    alt="Ortolab image"
                    onClick={() => {
                      window.open("https://ortolab.com.pl/", "_blank");
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </FullSection>

      <Container
        fluid
        className="ShadowHolder"
        style={{
          display: "flex",
          height: "7rem",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => goToPlace(ddsProRef)}
      >
        <Row className={"mt-5"}>
          <Col xs={12}>
            <Arrow />
          </Col>
        </Row>
      </Container>

      <FullSection pageStyle={"FullPage"}>
        <Container>
          <Row>
            <Col xs={12} className="text-center pb-4" ref={ddsProRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5">
                <b>{i18n.t("section_title_0")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span className="TopCardSpanText">
                  {i18n.t("title3_0")} <br />
                  {i18n.t("title3_1")} <br />
                  {i18n.t("title3_2")} <br />
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center pr-5 pb-5"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "5rem",
                }}
              >
                <Image
                  src={DDSPro}
                  style={{ maxHeight: "20rem", maxWidth: "20rem" }}
                />
                <Image
                  src={"https://dds-pro.com.pl/images/dds-ce.PNG"}
                  style={{
                    maxHeight: "20rem",
                    maxWidth: "15rem",
                    opacity: 1,
                    position: "absolute",
                    marginTop: "15rem",
                  }}
                />
              </div>
            </Col>
            <Col
              xs={12}
              lg={6}
              className={"pl-1 pr-0 textHolder"}
              style={{ paddingTop: "3rem" }}
            >
              <span>
                {i18n.t("bt3_0_0")}
                <b>{i18n.t("bt3_0")} </b>
                {i18n.t("bt3_1")}
                <br />
                <br />
                {i18n.t("bt3_2")}
                <ul className="SmallList">
                  <li>{i18n.t("bt3_3")}</li>
                  <li>{i18n.t("bt3_4")}</li>
                  <li>{i18n.t("bt3_5")}</li>
                  <li>{i18n.t("bt3_6")}</li>
                  <li>{i18n.t("bt3_7")}</li>
                  <li>{i18n.t("bt3_8")}</li>
                  <li>{i18n.t("bt3_9")}</li>
                  <li>{i18n.t("bt3_10")}</li>
                  <li>
                    {i18n.t("bt3_11_0")} {i18n.t("bt3_11_1")}{" "}
                    {i18n.t("bt3_11_2")}
                  </li>
                </ul>
                <br />
                <b>{i18n.t("bt3_12")}</b> {i18n.t("bt3_13")}
              </span>
            </Col>

            <Col xs={12} lg={3} className="pr-5">
              <Row className=" d-flex justify-content-center align-items-center w-100 form-group pb-4">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage6}
                    onClick={() => {
                      setOpenPicture1PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture1PopUp}
                  setShowPopUp={() => {
                    setOpenPicture1PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage6Popup} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 form-group pb-4">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage5}
                    onClick={() => {
                      setOpenPicture2PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture2PopUp}
                  setShowPopUp={() => {
                    setOpenPicture2PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage5Popup} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100   form-group">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage7}
                    onClick={() => {
                      setOpenPicture3PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture3PopUp}
                  setShowPopUp={() => {
                    setOpenPicture3PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage7Popup} rounded />
                </PopUp>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Alert.Link
              href="https://dds-pro.com.pl/dds-pro.html"
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPageSnd"}>
        <Container>
          <Row>
            <Col xs={12} className="text-center mb-5 pb-3" ref={ddpOrthoRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5">
                <b>{i18n.t("section_title_1")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span className="TopCardSpanText">
                  {i18n.t("title2_0")} <br />
                  {i18n.t("title2_1")} <br />
                  {i18n.t("title2_2")} <br />
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center pr-5 pb-5"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "5rem",
                }}
              >
                <Image
                  src={DDPOrtho}
                  style={{ maxHeight: "20rem", maxWidth: "20rem" }}
                />

                <Image
                  src={"https://dds-pro.com.pl/images/dds-ce.PNG"}
                  style={{
                    maxHeight: "20rem",
                    maxWidth: "15rem",
                    opacity: 1,
                    position: "absolute",
                    marginTop: "15rem",
                  }}
                />
              </div>
            </Col>

            <Col xs={12} lg={5} className="pb-5 pl-1">
              <span>
                <b>{i18n.t("bt2_0")}</b> {i18n.t("bt2_1")} <br />{" "}
                {i18n.t("bt2_2")} {i18n.t("bt2_3")} <b>{i18n.t("bt2_4")}</b>{" "}
                {i18n.t("bt2_5")}
              </span>
              <br />
              <br />
              <ul className="SmallList">
                <li>{i18n.t("bt2_6")}</li>
                <li>{i18n.t("bt2_7")}</li>
                <li>{i18n.t("bt2_8")}</li>
                <li>{i18n.t("bt2_9")}</li>
                <li>{i18n.t("bt2_10")}</li>
                <li>{i18n.t("bt2_11")}</li>
                <li>{i18n.t("bt2_12")}</li>
                <li>{i18n.t("bt2_13")}</li>
                <ul className="SmallListSnd">
                  <li>{i18n.t("bt2_14")}</li>
                  <li>{i18n.t("bt2_15")}</li>
                  <li>{i18n.t("bt2_16")}</li>
                </ul>
              </ul>
              <br />
              <span>
                {i18n.t("bt2_17_0")}
                <b>{i18n.t("bt2_17")}</b>
              </span>
              <span>{i18n.t("bt2_18")}</span>
            </Col>
            <Col />
            <Col xs={12} lg={3} className="pr-5">
              <Row
                className=" d-flex justify-content-center align-items-center w-100  form-group"
                style={{ height: "20%" }}
              >
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      style={{ width: "80%", height: "80%" }}
                      fluid
                      src={OrthoImage11}
                      rounded
                    />
                    <Image
                      src={Play}
                      className="VideoPlayer"
                      onClick={() => setOpenVideo1PopUp(true)}
                    />
                  </div>
                  <PopUp
                    modalSize="xl"
                    modalStyle="VideoModal"
                    closeBtnStyle="btn-content-video"
                    showPopUp={openVideo1PopUp}
                    setShowPopUp={setOpenVideo1PopUp}
                    modalHeader
                  >
                    {/* <video controls src={Video1} autoPlay="true" style={{ height: '100%', width: '100%' }} /> */}
                    <ReactPlayer
                      url="https://www.youtube.com/watch?v=bviJirOJuho"
                      width="60vw"
                      height="40vw"
                      controls={true}
                      playing={true}
                    />
                  </PopUp>
                </div>
              </Row>

              <Row
                className=" d-flex justify-content-center align-items-center w-100  form-group"
                style={{ height: "20%" }}
              >
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      style={{ width: "80%", height: "80%" }}
                      fluid
                      src={OrthoImage10}
                      rounded
                    />
                    <Image
                      src={Play}
                      className="VideoPlayer"
                      onClick={() => setOpenVideo2PopUp(true)}
                    />
                  </div>
                  <PopUp
                    modalSize="xl"
                    modalStyle="VideoModal"
                    closeBtnStyle="btn-content-video"
                    showPopUp={openVideo2PopUp}
                    setShowPopUp={setOpenVideo2PopUp}
                    modalHeader
                  >
                    {/* <video controls src={Video2} autoPlay="true" style={{ height: '100%', width: '100%' }} /> */}
                    <ReactPlayer
                      url="https://www.youtube.com/watch?v=PagvTDG79rI&ab_channel=DDP-Ortho"
                      width="60vw"
                      height="40vw"
                      controls={true}
                      playing={true}
                    />
                  </PopUp>
                </div>
              </Row>

              <Row
                className=" d-flex justify-content-center align-items-center w-100  form-group"
                style={{ height: "20%" }}
              >
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      style={{ width: "80%", height: "80%" }}
                      fluid
                      src={OrthoImage9}
                      rounded
                    />
                    <Image
                      src={Play}
                      className="VideoPlayer"
                      onClick={() => setOpenVideo3PopUp(true)}
                    />
                  </div>
                  <PopUp
                    modalSize="xl"
                    modalStyle="VideoModal"
                    closeBtnStyle="btn-content-video"
                    showPopUp={openVideo3PopUp}
                    setShowPopUp={setOpenVideo3PopUp}
                    modalHeader
                  >
                    {/* <video controls src={Video3} autoPlay="true" style={{ height: '100%', width: '100%' }} /> */}
                    <ReactPlayer
                      url="https://www.youtube.com/watch?v=FAKGQ8YZQ1g"
                      width="60vw"
                      height="40vw"
                      controls={true}
                      playing={true}
                    />
                  </PopUp>
                </div>
              </Row>

              <Row
                className=" d-flex justify-content-center align-items-center w-100  form-group pb-1"
                style={{ height: "20%" }}
              >
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      style={{ width: "80%", height: "80%" }}
                      fluid
                      src={OrthoImage8}
                      rounded
                    />
                    <Image
                      src={Play}
                      className="VideoPlayer"
                      onClick={() => setOpenVideo4PopUp(true)}
                    />
                  </div>
                  <PopUp
                    modalSize="xl"
                    modalStyle="VideoModal"
                    closeBtnStyle="btn-content-video"
                    showPopUp={openVideo4PopUp}
                    setShowPopUp={setOpenVideo4PopUp}
                    modalHeader
                  >
                    {/* <video controls src={Video4} autoPlay="true" style={{ height: '100%', width: '100%' }} /> */}
                    <ReactPlayer
                      url="https://www.youtube.com/watch?v=MvLARpVhwJQ"
                      width="60vw"
                      height="40vw"
                      controls={true}
                      playing={true}
                    />
                  </PopUp>
                </div>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            {/* <Button
              onClick={() => { window.open("https://orthomodels.com.pl/", '_blank') }}
              block
              className="DDPOrthoSoftwareBtn"
              variant="outline-primary"
              style={{ width: '30%', height: '4rem', minWidth: '8rem', margin: '0' }}
            > */}
            <Alert.Link
              href="https://orthomodels.com.pl/"
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
            {/* {i18n.t("ShowMore")}
            </Button> */}
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPage FullPageFix"}>
        <Container className={"mb-5"}>
          <Row>
            <Col
              xs={12}
              className="text-center pb-3"
              ref={ortoModelsRef}
              style={{ marginBottom: "1.5rem" }}
            >
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="mb-5" style={{ position: "relative" }}>
                <b>{i18n.t("section_title_2")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span className="TopCardSpanText">
                  {i18n.t("title1_0")} <br />
                  {i18n.t("title1_1")} <br />
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center "
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  //paddingBottom: '5rem',
                  maxHeight: "15rem",
                  maxWidth: "15rem",
                }}
              >
                <div className="CardImageBottom " style={{ zIndex: "5" }}>
                  <Image
                    src={DDPOrtho}
                    alt="Card image"
                    fluid
                    style={{ zIndex: "5" }}
                  />
                </div>

                <Image
                  fluid
                  src={OrthoImage2}
                  style={{
                    maxHeight: "15rem",
                    maxWidth: "15rem",
                    zIndex: "1",
                    paddingBottom: "2rem",
                  }}
                  className="rounded"
                />
              </div>
            </Col>

            <Col xs={12} lg={6} className={"pl-1 pr-0 textHolder"}>
              <span>
                {i18n.t("bt1_0_0")}
                <b>{i18n.t("bt1_0")}</b>
              </span>
              <span>{i18n.t("bt1_1")}</span>
              <span>
                {i18n.t("bt1_2")} <br />
              </span>
              <span>{i18n.t("bt1_3")}</span>
              <span>
                <b>{i18n.t("bt1_4")}</b>
              </span>
              <p>
                {i18n.t("bt1_5")} <br />
              </p>
              <ul className="SmallList">
                <li>{i18n.t("bt1_6")}</li>
                <li>{i18n.t("bt1_7")}</li>
                <li>{i18n.t("bt1_8")}</li>
              </ul>
              <br />
              <span>{i18n.t("bt1_9")}</span>
              <span>
                {" "}
                <b>{i18n.t("bt1_10")}</b>
              </span>
              <span>{i18n.t("bt1_11")}</span>
              <span>
                <b>{i18n.t("bt1_12")}</b>
              </span>
              <span>{i18n.t("bt1_13")}</span>
              <span>
                <b>{i18n.t("bt1_14")}</b>
              </span>
              <span>
                {i18n.t("bt1_14_1")}
                <br />
              </span>
              <br></br>

              <span>
                {i18n.t("bt1_15_0")}
                <b>{i18n.t("bt1_15")}</b>
              </span>
              <span>
                {i18n.t("bt1_16")}
                <br />
              </span>
              <br />
              <ul className="SmallList">
                <li>{i18n.t("bt1_17")}</li>
                <li>{i18n.t("bt1_18")}</li>
                <li>{i18n.t("bt1_19")}</li>
                <li>{i18n.t("bt1_20")}</li>
                <li>{i18n.t("bt1_21")}</li>
              </ul>
              <br />
              <span>
                <p>
                  {" "}
                  <b>{i18n.t("bt1_22_1")}</b> {i18n.t("bt1_22")}{" "}
                </p>
                <br />
              </span>

              <span>
                <p>
                  {i18n.t("bt1_23_0")} <b>{i18n.t("bt1_23_1")}</b>{" "}
                  {i18n.t("bt1_23")}{" "}
                </p>
                <br />
              </span>
            </Col>

            <Col
              xs={12}
              lg={3}
              className="p-4"
              style={{ paddingTop: 0 + "!important" }}
            >
              <Row className=" d-flex justify-content-center align-items-center w-100 form-group">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <p style={{ textAlign: "center" }}>Basic</p>
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage28}
                    onClick={() => {
                      setOpenPicture4PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture4PopUp}
                  setShowPopUp={() => {
                    setOpenPicture4PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className=""
                    fluid
                    src={OrthoImage28}
                    rounded
                    style={{ width: "45rem" }}
                  />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 form-group">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <p style={{ textAlign: "center" }}>SemiPro</p>
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage29}
                    onClick={() => {
                      setOpenPicture5PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture5PopUp}
                  setShowPopUp={() => {
                    setOpenPicture5PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className=""
                    fluid
                    src={OrthoImage29}
                    rounded
                    style={{ width: "45rem" }}
                  />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100   form-group">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <p style={{ textAlign: "center" }}>Pro</p>
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage30}
                    onClick={() => {
                      setOpenPicture6PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture6PopUp}
                  setShowPopUp={() => {
                    setOpenPicture6PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className=""
                    fluid
                    src={OrthoImage30}
                    rounded
                    style={{ width: "45rem" }}
                  />
                </PopUp>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            {/* <Button
              onClick={() => { window.open("https://ortodonta.com/en/ddp-ortho-2", '_blank') }}
              block
              className=""
              variant="outline-primary"
              style={{ width: '30%', height: '4rem', minWidth: '8rem' }}
            >
              {i18n.t("ShowMore")}
            </Button> */}
            <Alert.Link
              href={
                flag === "pl"
                  ? "https://ortodonta.com/ddp-ortho/"
                  : "https://ortodonta.com/en/ddp-ortho-2"
              }
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPage"}>
        <Container>
          <Row>
            <Col xs={12} className="text-center pb-3" ref={dtsRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5">
                <b>{i18n.t("section_title_3")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span className="TopCardSpanText">
                  {i18n.t("title5_0")} <br />
                  {i18n.t("title5_1")} <br />
                  {i18n.t("title5_2")} <br />
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-start "
            >
              <div
                className={"dtsLogo"}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image fluid src={DTS} />
              </div>
            </Col>
            <Col xs={12} lg={5} style={{ paddingTop: "4rem" }}>
              {flag == "en" ? (
                <span>
                  <b>{i18n.t("bt5_0")}</b>
                  {i18n.t("bt5_1")}
                  {i18n.t("bt5_2")}
                  {i18n.t("bt5_3")}
                  <b>{i18n.t("bt5_4")}</b>
                  {i18n.t("bt5_5")}
                  <br />
                  <br />
                  <ul className="SmallList">
                    <li>{i18n.t("bt5_6")}</li>
                    <li>{i18n.t("bt5_7")}</li>
                    <li>
                      {i18n.t("bt5_8_0")} <b>{i18n.t("bt5_8_1")}</b>
                      {i18n.t("bt5_8_2")}
                    </li>
                    <li>{i18n.t("bt5_9")}</li>
                    <li>{i18n.t("bt5_10")}</li>
                  </ul>
                  <br />
                  <b>{i18n.t("bt5_11")}</b>
                  {i18n.t("bt5_12")}
                  <br />
                  <br />
                </span>
              ) : (
                <span>
                  <b>{i18n.t("bt5_0")}</b>
                  {i18n.t("bt5_1")}
                  {i18n.t("bt5_2")}
                  {i18n.t("bt5_3")}
                  <b>{i18n.t("bt5_4")}</b>
                  {i18n.t("bt5_5")}
                  <br />
                  <ul className="SmallList">
                    <li>
                      <b>{i18n.t("bt5_6_0")}</b>
                      {i18n.t("bt5_6")}
                    </li>
                    <li>
                      <b>{i18n.t("bt5_7_0")}</b>
                      {i18n.t("bt5_7")}
                    </li>
                    <li>
                      <b>{i18n.t("bt5_8_0_0")}</b>
                      {i18n.t("bt5_8_0")}
                    </li>
                    <li>
                      <b>{i18n.t("bt5_8_1")}</b>
                      {i18n.t("bt5_8_2")}
                    </li>
                  </ul>
                  <br />
                  <b>{i18n.t("bt5_11")}</b>
                  {i18n.t("bt5_12")}
                  <br />
                  <br />
                </span>
              )}
            </Col>
            <Col xs={12} lg={4} className="dtsSchemeColumn mt-4">
              <div
                style={{ height: "100%", width: "100%", position: "relative" }}
              >
                <Row style={{ height: `${customDTSHeight + 5}%` }}>
                  <Col
                    xs={6}
                    lg={6}
                    className=" d-flex justify-content-center align-items-center h-100"
                  >
                    <Row className="h-100 d-flex justify-content-center mb-5 ">
                      <div
                        style={{
                          width: "70%",
                          height: "78%",
                          display: "flex",
                          justifyContent: "right",
                        }}
                      >
                        <Image
                          className="ImageHover"
                          style={{
                            width: "100%",
                            height: "100%",
                            marginRight: "1.5rem",
                          }}
                          fluid
                          src={OrthoImage12}
                          rounded
                          onClick={() => {
                            setOpenPicture18PopUp(true);
                          }}
                        />
                      </div>
                      <PopUp
                        modalSize="xl"
                        modalStyle="VideoModal"
                        closeBtnStyle="btn-content-picture"
                        showPopUp={openPicture18PopUp}
                        setShowPopUp={() => {
                          setOpenPicture18PopUp(false);
                        }}
                        modalHeader
                      >
                        <Image
                          className=""
                          fluid
                          src={OrthoImage12}
                          rounded
                          style={{ width: "45rem" }}
                        />
                      </PopUp>
                    </Row>
                  </Col>

                  <Col xs={6} lg={6} className=" h-100">
                    <Row className=" h-100 d-flex justify-content-start align-items-end ">
                      <div
                        className="dtsSchemeLinesTop"
                        style={{
                          display: "flex",
                          borderTop: "0.2rem solid #3f85c6",
                          borderRight: "0.2rem solid #3f85c6",
                          height: "100%",
                          //width: '5.5rem',
                          textAlign: "left",
                          alignItems: "flex-start",
                          justifyContent: "flex-end",
                          //fontSize:'0.9375rem'
                        }}
                      >
                        <span>
                          {i18n.t("bt5_13_0")} <br />
                          {i18n.t("bt5_13_1")} <br />
                          {i18n.t("bt5_13_2")} <br />
                        </span>
                      </div>
                    </Row>
                  </Col>
                </Row>

                <Row
                  className="mt-1"
                  style={{ height: `${customDTSHeight + 1}%` }}
                >
                  <Col xs={6} lg={6} className="  h-100">
                    <Row className="h-100 d-flex justify-content-center align-items-center">
                      <div
                        className="dtsSchemeText"
                        style={{
                          display: "flex",
                          width: "100%",
                          height: "100%",
                          justifyContent: "flex-end",
                          // alignItems: 'flex-end',
                          textAlign: "right",
                          //fontSize:'0.9375rem',
                        }}
                      >
                        <span>
                          {i18n.t("bt5_14_0")} <br />
                          {i18n.t("bt5_14_1")} <br />
                        </span>
                      </div>
                    </Row>
                  </Col>

                  <Col
                    xs={6}
                    lg={6}
                    className=" d-flex justify-content-center align-items-center h-100"
                  >
                    <Row className="h-100 justify-content-center">
                      <div
                        style={{
                          width: "70%",
                          height: "100%",
                        }}
                      >
                        <Image
                          className="ImageHover"
                          style={{ width: "100%", height: "100%" }}
                          fluid
                          src={OrthoImage13}
                          rounded
                          onClick={() => {
                            setOpenPicture19PopUp(true);
                          }}
                        />
                      </div>
                      <PopUp
                        modalSize="xl"
                        modalStyle="VideoModal"
                        closeBtnStyle="btn-content-picture"
                        showPopUp={openPicture19PopUp}
                        setShowPopUp={() => {
                          setOpenPicture19PopUp(false);
                        }}
                        modalHeader
                      >
                        <Image
                          className=""
                          fluid
                          src={OrthoImage13}
                          rounded
                          style={{ width: "45rem" }}
                        />
                      </PopUp>
                    </Row>
                  </Col>
                </Row>
                <Row style={{ height: `${customDTSHeight - 3}%` }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      height: "100%",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="dtsSchemeLineCenterBot"
                      style={{
                        borderRight: "0.2rem solid #3f85c6",
                        height: "2rem",
                        //width: '11rem',
                        textAlign: "center",
                      }}
                    ></div>
                    <div
                      className="dtsSchemeLinesCenterBot"
                      style={{
                        borderTop: "0.2rem solid #3f85c6",
                        borderLeft: "0.2rem solid #3f85c6",
                        borderRight: "0.2rem solid #3f85c6",
                        height: "2rem",
                        //width: '12rem',
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {i18n.t("bt5_15_0")} <br />
                        {i18n.t("bt5_15_1")} <br />
                      </span>
                    </div>
                  </div>
                </Row>
                <Row style={{ height: `${customDTSHeight + 8}%` }}>
                  <Col xs={6} lg={6} className="h-100">
                    <Row className="h-100 d-flex justify-content-end align-items-end">
                      <div
                        className="dtsSchemeText"
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          //fontSize:'0.9375rem'
                        }}
                      >
                        <span>{i18n.t("bt5_16")}</span>
                        <Image
                          className="ImageHover"
                          style={{ width: "70%", height: "70%" }}
                          fluid
                          src={OrthoImage14}
                          rounded
                          onClick={() => {
                            setOpenPicture20PopUp(true);
                          }}
                        />
                      </div>
                      <PopUp
                        modalSize="xl"
                        modalStyle="VideoModal"
                        closeBtnStyle="btn-content-picture"
                        showPopUp={openPicture20PopUp}
                        setShowPopUp={() => {
                          setOpenPicture20PopUp(false);
                        }}
                        modalHeader
                      >
                        <Image
                          className=""
                          fluid
                          src={OrthoImage14}
                          rounded
                          style={{ width: "45rem" }}
                        />
                      </PopUp>
                    </Row>
                  </Col>

                  <Col xs={6} lg={6} className="h-100">
                    <Row className="h-100 d-flex justify-content-end align-items-end">
                      <div
                        className="dtsSchemeText"
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <span>{i18n.t("bt5_17")}</span>
                        <Image
                          className="ImageHover"
                          style={{ width: "70%", height: "70%" }}
                          fluid
                          src={OrthoImage15}
                          rounded
                          onClick={() => {
                            setOpenPicture21PopUp(true);
                          }}
                        />
                      </div>
                      <PopUp
                        modalSize="xl"
                        modalStyle="VideoModal"
                        closeBtnStyle="btn-content-picture"
                        showPopUp={openPicture21PopUp}
                        setShowPopUp={() => {
                          setOpenPicture21PopUp(false);
                        }}
                        modalHeader
                      >
                        <Image
                          className=""
                          fluid
                          src={OrthoImage15}
                          rounded
                          style={{ width: "45rem" }}
                        />
                      </PopUp>
                    </Row>
                  </Col>
                </Row>

                <Row
                  className="pb-2"
                  style={{ height: `${customDTSHeight - 2}%` }}
                >
                  <div
                    style={{
                      flexDirection: "row",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        height: "45%",
                        justifyContent: "center",
                        alignItems: "flex-end",
                      }}
                    >
                      <div
                        className="dtsSchemeLinesCenterBot"
                        style={{
                          borderBottom: "0.2rem solid #3f85c6",
                          borderLeft: "0.2rem solid #3f85c6",
                          borderRight: "0.2rem solid #3f85c6",
                          height: "2.375rem",
                          //width: '12rem',
                        }}
                      ></div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        height: "5%",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "0.1rem solid #3f85c6",
                          borderRight: "0.1rem solid #3f85c6",
                          height: "100%",
                          width: 0,
                          backgroundColor: "#3f85c6",
                        }}
                      ></div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        height: "45%",
                        justifyContent: "center",
                        alignItems: "flex-start",
                      }}
                    >
                      <div
                        className="dtsSchemeLinesCenterBot"
                        style={{
                          borderTop: "0.2rem solid #3f85c6",
                          borderLeft: "0.2rem solid #3f85c6",
                          borderRight: "0.2rem solid #3f85c6",
                          height: "2.375rem",
                          //width: '12rem',
                          textAlign: "center",
                          //fontSize:'0.9375rem'
                        }}
                      >
                        <span>
                          {i18n.t("bt5_18_0")} <br />
                          {i18n.t("bt5_18_1")}
                        </span>
                      </div>
                    </div>
                  </div>
                </Row>

                <Row
                  className="pl-4 mt-3"
                  style={{ height: `${customDTSHeight - 4}%` }}
                >
                  <Col xs={6} lg={6} className="h-100 ">
                    <Row className="h-100 d-flex justify-content-endalign-items-end pr-2">
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Image
                          style={{ width: "80%", height: "80%" }}
                          fluid
                          src={flag == "en" ? IPA_EN : IPA_PL}
                          rounded
                        />
                      </div>
                    </Row>
                  </Col>

                  <Col xs={6} lg={6} className="h-100 ">
                    <Row className="h-100 d-flex justify-content-end align-items-end pl-2">
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          paddingLeft: "0.75rem",
                        }}
                      >
                        <Image
                          style={{
                            width: "80%",
                            height: "72%",
                            objectFit: "contain",
                          }}
                          fluid
                          src={flag === "pl" ? OrthoImage32pl : OrthoImage32BQ}
                          rounded
                        />
                      </div>
                    </Row>
                  </Col>
                </Row>

                <Row className="pl-4" style={{ height: `${customDTSHeight}%` }}>
                  <Col xs={6} lg={6} className="h-100 ">
                    <Row className="h-100 d-flex justify-content-end align-items-end pr-2">
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Image
                          className="ImageHover"
                          style={{ width: "80%", height: "100%" }}
                          fluid
                          src={OrthoImage16}
                          rounded
                          onClick={() => {
                            setOpenPicture22PopUp(true);
                          }}
                        />
                      </div>
                      <PopUp
                        modalSize="xl"
                        modalStyle="VideoModal"
                        closeBtnStyle="btn-content-picture"
                        showPopUp={openPicture22PopUp}
                        setShowPopUp={() => {
                          setOpenPicture22PopUp(false);
                        }}
                        modalHeader
                      >
                        <Image
                          className=""
                          fluid
                          src={OrthoImage16}
                          rounded
                          style={{ width: "45rem" }}
                        />
                      </PopUp>
                    </Row>
                  </Col>

                  <Col xs={6} lg={6} className="h-100 ">
                    <Row className="h-100 d-flex justify-content-end align-items-end ">
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          paddingLeft: "0.75rem",
                        }}
                      >
                        <Image
                          className="ImageHover"
                          style={{ width: "80%", height: "100%" }}
                          fluid
                          src={OrthoImage17}
                          rounded
                          onClick={() => {
                            setOpenPicture23PopUp(true);
                          }}
                        />
                      </div>
                      <PopUp
                        modalSize="xl"
                        modalStyle="VideoModal"
                        closeBtnStyle="btn-content-picture"
                        showPopUp={openPicture23PopUp}
                        setShowPopUp={() => {
                          setOpenPicture23PopUp(false);
                        }}
                        modalHeader
                      >
                        <Image
                          className=""
                          fluid
                          src={OrthoImage17}
                          rounded
                          style={{ width: "45rem" }}
                        />
                      </PopUp>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            {/* <Button
              onClick={() => { window.open("https://ortomodels.com.pl/Software", '_blank') }}
              block
              className=""
              variant="outline-primary"
              style={{ width: '30%', height: '4rem', minWidth: '8rem' }}
            >
              {i18n.t("ShowMore")}
            </Button> */}
            <Alert.Link
              href="https://ortomodels.com.pl/Software"
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPageSnd"}>
        <Container className={"mb-5"}>
          <Row>
            <Col xs={12} className="text-center pb-4" ref={ortonetRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5">
                <b>{i18n.t("section_title_4")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span className="TopCardSpanText">
                  {i18n.t("title4_0")} <br />
                  {i18n.t("title4_1")} <br />
                  {i18n.t("title4_2")} <br />
                </span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center pr-5"
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  height: "75%",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "5rem",
                }}
              >
                <Image
                  src={Ortonet1}
                  style={{ maxHeight: "20rem", maxWidth: "20rem" }}
                />
                {/* <Image
                  onClick={(e) => goToPlace(heloRef)}
                  src={Helo}
                  className={"smallHeloLogo"}
                  style={{
                    position: "absolute",
                    bottom: "-1rem",
                    maxHeight: "10rem",
                    maxWidth: "15rem",
                    cursor: "pointer",
                  }}
                /> */}
              </div>
            </Col>

            <Col
              xs={12}
              lg={6}
              className={"pl-1 pr-0 textHolder"}
              style={{ paddingTop: "4rem" }}
            >
              <span>
                <b>{i18n.t("bt4_0")}</b>
                {i18n.t("bt4_1")}
                <br />
                <br />
                {i18n.t("bt4_2")}
                <ul className="SmallList">
                  <li>
                    {i18n.t("bt4_3_0")} <b>{i18n.t("bt4_3_1")}</b>
                    {i18n.t("bt4_3_2")}
                  </li>
                  <li>{i18n.t("bt4_4")}</li>
                  <li>{i18n.t("bt4_5")}</li>
                  <li>{i18n.t("bt4_6")}</li>
                  <li>
                    {i18n.t("bt4_7")} <b>{i18n.t("bt4_8_1")}</b>{" "}
                    {i18n.t("bt4_8_2")}{" "}
                  </li>
                  <li>{i18n.t("bt4_8")}</li>
                  <li>{i18n.t("bt4_11")}</li>
                </ul>
                <br />
                <b>{i18n.t("bt4_9")}</b>
                {i18n.t("bt4_10")}
              </span>
            </Col>

            <Col xs={12} lg={3}>
              <Row className=" d-flex justify-content-center align-items-center w-100 h-25 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage18}
                    onClick={() => {
                      setOpenPicture7PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture7PopUp}
                  setShowPopUp={() => {
                    setOpenPicture7PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage18} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 h-25 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage19}
                    onClick={() => {
                      setOpenPicture8PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture8PopUp}
                  setShowPopUp={() => {
                    setOpenPicture8PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage19} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 h-25 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage20}
                    onClick={() => {
                      setOpenPicture9PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture9PopUp}
                  setShowPopUp={() => {
                    setOpenPicture9PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage20} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 h-25 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage21}
                    onClick={() => {
                      setOpenPicture10PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture10PopUp}
                  setShowPopUp={() => {
                    setOpenPicture10PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={OrthoImage21} rounded />
                </PopUp>
              </Row>
            </Col>
          </Row>
          <PopUp
            modalSize="xl"
            modalStyle="VideoModal"
            closeBtnStyle="btn-content-picture"
            showPopUp={openPicture17PopUp}
            setShowPopUp={() => {
              setOpenPicture17PopUp(false);
            }}
            modalHeader
          >
            <Image
              className=""
              style={{ width: "45rem" }}
              fluid
              src={OrthoImage35}
              rounded
            />
          </PopUp>
          <Row className="d-flex justify-content-center">
            {/* <Button
              onClick={() => { window.open("https://www.ortonet.systems/", '_blank') }}
              block
              className=""
              variant="outline-primary"
              style={{ width: '30%', height: '4rem', minWidth: '8rem' }}
            >
              {i18n.t("ShowMore")}
            </Button> */}
            <Alert.Link
              href="https://www.ortonet.systems/"
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPage"}>
        <Container className={"mb-5"}>
          <Row>
            <Col xs={12} className="text-center pb-4" ref={heloRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5 sectionHeloTitle">
                <b>
                  {i18n.t("section_title_8")}
                  {i18n.t("section_title_8_1")}
                </b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span className="TopCardSpanText">
                  {i18n.t("title8_0")} <br /> {i18n.t("title8_1")}
                </span>
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center pr-5"
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "5rem",
                }}
              >
                <Image
                  src={Helo}
                  style={{ maxHeight: "20rem", maxWidth: "20rem" }}
                />
                {/* <Image
                  src={Ortonet1}
                  onClick={(e) => goToPlace(ortonetRef)}
                  className={"smallOrtoLogo"}
                  style={{
                    position: "absolute",
                    bottom: "-1rem",
                    maxHeight: "10rem",
                    maxWidth: "10rem",
                    cursor: "pointer",
                  }}
                /> */}
              </div>
            </Col>

            <Col
              xs={12}
              lg={6}
              className={"pl-1 pr-0 textHolder"}
              style={{ paddingTop: "4rem" }}
            >
              <span>
                <b>{i18n.t("bt8_0")} </b>
                {i18n.t("bt8_1")}
                <br />
                <br />
                {i18n.t("bt8_2")}
                <ul className="SmallList">
                  <li>
                    {i18n.t("bt8_3_0")}
                    {i18n.t("bt8_3_1")}
                  </li>
                  <li>{i18n.t("bt8_3_2")}</li>
                  <li>{i18n.t("bt8_3_3")}</li>
                  <li>{i18n.t("bt8_3_4")}</li>
                </ul>
                <br />
                {i18n.t("bt8_4")}
                <b>{i18n.t("bt8_4_0")}</b>
                {i18n.t("bt8_4_1")}
                <b>{i18n.t("bt8_4_2")}</b>
                {i18n.t("bt8_4_3")}
              </span>
            </Col>

            <Col xs={12} lg={3}>
              <Row className=" d-flex justify-content-center align-items-center w-100 h-48 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={Helo1}
                    onClick={() => {
                      setOpenPicture25PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture25PopUp}
                  setShowPopUp={() => {
                    setOpenPicture25PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={Helo1} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100  ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={Helo2}
                    onClick={() => {
                      setOpenPicture24PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture24PopUp}
                  setShowPopUp={() => {
                    setOpenPicture24PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={Helo2} rounded />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 h-60 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={Helo3}
                    onClick={() => {
                      setOpenPicture26PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture26PopUp}
                  setShowPopUp={() => {
                    setOpenPicture26PopUp(false);
                  }}
                  modalHeader
                >
                  <Image className="" fluid src={Helo3} rounded />
                </PopUp>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mt-5">
            <Alert.Link
              href="https://helo-ortho.com.pl"
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPage"}>
        <Container>
          <Row>
            <Col xs={12} className="text-center pb-2" ref={ipaRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5">
                <b>{i18n.t("section_title_5")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span
                  className="TopCardSpanText "
                  style={{ textAlign: "center", padding: 0 }}
                >
                  {i18n.t("title6_0")} <br />
                  {i18n.t("title6_1")} <br />
                  {i18n.t("title6_2")} <br />
                  {i18n.t("title6_3")} <br />
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center pb-5"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "5rem",
                  marginBottom: "5rem",
                }}
              >
                <Image
                  src={flag == "en" ? IPA_EN : IPA_PL}
                  style={{
                    maxHeight: "10rem",
                    maxWidth: "10.3rem",
                    marginBottom: "1.2rem",
                  }}
                />

                <Image
                  src={OrthoImage25}
                  style={{
                    maxHeight: "10rem",
                    maxWidth: "10rem",
                    opacity: 1,
                    position: "absolute",
                    marginTop: "12rem",
                  }}
                  rounded
                />
              </div>
            </Col>
            <Col
              xs={12}
              lg={6}
              className={"pl-1 pr-0 textHolder"}
              style={{ paddingTop: "4rem" }}
            >
              <span>
                <b>{i18n.t("bt6_0")} </b>
                {i18n.t("bt6_1")}
                <b>{i18n.t("bt1_0")}</b>
                {i18n.t("bt6_2")}
                <br />
                <br />
                <br />
                {i18n.t("bt6_3")}
                <ul className="SmallList">
                  <li>{i18n.t("bt6_4")}</li>
                  <li>{i18n.t("bt6_5")}</li>
                  <li>{i18n.t("bt6_6")}</li>
                  <li>{i18n.t("bt6_7")}</li>
                </ul>
                <br />
                <br />
                <br />
                {i18n.t("bt6_8_0")}
                <b>{i18n.t("bt6_0")}</b>
                {i18n.t("bt6_8")}
                {i18n.t("bt1_0")}
                {i18n.t("bt6_9")}
                <br />
                {i18n.t("bt6_10")}
                <b>{i18n.t("bt5_2")}</b>
                {i18n.t("bt6_11")}
              </span>
            </Col>

            <Col xs={12} lg={3} className="p-4">
              <Row className=" d-flex justify-content-center align-items-center w-100 form-group pb-3">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage22}
                    onClick={() => {
                      setOpenPicture11PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture11PopUp}
                  setShowPopUp={() => {
                    setOpenPicture11PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className="PopUpImageSquare"
                    fluid
                    src={OrthoImage22}
                    rounded
                  />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 form-group pb-3">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage34}
                    onClick={() => {
                      setOpenPicture12PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture12PopUp}
                  setShowPopUp={() => {
                    setOpenPicture12PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className="PopUpImageSquare"
                    fluid
                    src={OrthoImage34}
                    rounded
                  />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 form-group">
                {/* <div style={{
                  width: '80%', height: '80%'
                }}>
                  <Image className = 'ImageHover' style={{ width: '100%', height: '100%' }} fluid src={OrthoImage33} onClick={() => {setOpenPicture13PopUp(true)}} rounded />
                  
                </div> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <Image
                    style={{ width: "80%", height: "80%" }}
                    fluid
                    src={OrthoImage33}
                    rounded
                  />
                  <Image
                    src={Play}
                    className="VideoPlayer"
                    onClick={() => setOpenVideo5PopUp(true)}
                  />
                </div>
                {/* <PopUp modalSize="xl" modalStyle='VideoModal' closeBtnStyle = 'btn-content-picture' showPopUp={openPicture13PopUp} setShowPopUp={() => {setOpenPicture13PopUp(false)}} modalHeader>
                  <Image className = 'PopUpImageSquare' fluid src={OrthoImage33} rounded />
                </PopUp> */}
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-video"
                  showPopUp={openVideo5PopUp}
                  setShowPopUp={setOpenVideo5PopUp}
                  modalHeader
                >
                  {/* <video controls src={Video4} autoPlay="true" style={{ height: '100%', width: '100%' }} /> */}
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=IFZSo_xUjR4&ab_channel=DDP-Ortho"
                    width="60vw"
                    height="40vw"
                    controls={true}
                    playing={true}
                  />
                </PopUp>
              </Row>
            </Col>
          </Row>

          <Row className="d-flex justify-content-center">
            {/* <Button
              onClick={() => { window.open("https://ortodonta.com/en/ipa/", '_blank') }}
              block
              className=""
              variant="outline-primary"
              style={{ width: '30%', height: '4rem', minWidth: '8rem' }}
            >
              {i18n.t("ShowMore")}
            </Button> */}
            <Alert.Link
              href={
                flag === "pl"
                  ? "https://ortodonta.com/ipa-pl/"
                  : "https://ortodonta.com/en/ipa/"
              }
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <FullSection pageStyle={"FullPage"}>
        <Container>
          <Row>
            <Col xs={12} className="text-center pb-2" ref={alignerRef}>
              <GoToTopArrow
                click={() => {
                  goToPlace("top");
                }}
              />
              <h1 className="SectionTitle mb-5">
                <b>{i18n.t("section_title_6")}</b>
              </h1>
              <div style={{ opacity: 0.8 }}>
                <span
                  className="TopCardSpanText "
                  style={{ textAlign: "center" }}
                >
                  {i18n.t("title7_0")} <br />
                  {i18n.t("title7_1")} <br />
                  {i18n.t("title7_2")} <br />
                  {/* {i18n.t("title7_3")} <br /> */}
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              lg={3}
              className=" d-flex text-center justify-content-center align-items-center pb-5"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "5rem",
                  marginBottom: "5rem",
                }}
              >
                <Image
                  src={flag === "pl" ? OrthoImage32pl : OrthoImage32BQ}
                  style={{
                    maxHeight: "10rem",
                    maxWidth: "10.5rem",
                    marginBottom: "0.4rem",
                  }}
                />

                <Image
                  src={OrthoImage37}
                  style={{
                    maxHeight: "10rem",
                    maxWidth: "10rem",
                    opacity: 1,
                    position: "absolute",
                    marginTop: "12rem",
                  }}
                  rounded
                />
              </div>
            </Col>
            <Col
              xs={12}
              lg={6}
              className={"pl-1 pr-0 textHolder"}
              style={{ paddingTop: "4rem" }}
            >
              <p>
                <b>{i18n.t("bt7_0")} </b>
                {i18n.t("bt7_1")}
                <b>{i18n.t("bt1_4")}</b>
                {i18n.t("bt7_2")}
                <br />
                <br />
                {i18n.t("bt7_3")}
                <ul className="SmallList">
                  <li>{i18n.t("bt7_4")}</li>
                  <li>{i18n.t("bt7_5")}</li>
                  <li>{i18n.t("bt7_6")}</li>
                  <li>{i18n.t("bt7_7")}</li>
                  <li>{i18n.t("bt7_8")}</li>
                  <li>{i18n.t("bt7_9")}</li>
                </ul>
                <br />
                {i18n.t("bt7_11_0")}
                <b>{i18n.t("bt7_0")}</b>
                {i18n.t("bt7_11")} <b> {i18n.t("bt1_0")}</b>
                {i18n.t("bt7_12")} {i18n.t("bt7_10")}
                <b>{i18n.t("bt5_2")}</b>
                {i18n.t("bt6_11")}
              </p>
            </Col>

            <Col xs={12} lg={3} className="p-4">
              <Row className=" d-flex justify-content-center align-items-center w-100 form-group pb-3 ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage26}
                    onClick={() => {
                      setOpenPicture14PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture14PopUp}
                  setShowPopUp={() => {
                    setOpenPicture14PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className=""
                    fluid
                    src={OrthoImage26Popup}
                    rounded
                    style={{ width: "45rem" }}
                  />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 form-group pb-3">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage27}
                    onClick={() => {
                      setOpenPicture15PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture15PopUp}
                  setShowPopUp={() => {
                    setOpenPicture15PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className=""
                    fluid
                    src={OrthoImage27Popup}
                    rounded
                    style={{ width: "45rem" }}
                  />
                </PopUp>
              </Row>

              <Row className=" d-flex justify-content-center align-items-center w-100 form-group ">
                <div
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                >
                  <Image
                    className="ImageHover"
                    style={{ width: "100%", height: "100%" }}
                    fluid
                    src={OrthoImage24}
                    onClick={() => {
                      setOpenPicture16PopUp(true);
                    }}
                    rounded
                  />
                </div>
                <PopUp
                  modalSize="xl"
                  modalStyle="VideoModal"
                  closeBtnStyle="btn-content-picture"
                  showPopUp={openPicture16PopUp}
                  setShowPopUp={() => {
                    setOpenPicture16PopUp(false);
                  }}
                  modalHeader
                >
                  <Image
                    className=""
                    fluid
                    src={OrthoImage24Popup}
                    rounded
                    style={{ width: "45rem" }}
                  />
                </PopUp>
              </Row>
            </Col>
          </Row>

          <Row className="d-flex justify-content-center">
            {/* <Button
              onClick={() => { window.open("https://ortodonta.com/en/a-ligner-3/", '_blank') }}
              block
              className=""
              variant="outline-primary"
              style={{ width: '30%', height: '4rem', minWidth: '8rem' }}
            >
              {i18n.t("ShowMore")}
            </Button> */}
            <Alert.Link
              href={
                flag === "pl"
                  ? "https://ortodonta.com/a-ligner/"
                  : "https://ortodonta.com/en/a-ligner-3/"
              }
              block
              target="_blank"
              className="Links"
              variant="outline-primary"
              style={{ fontWeight: 300 }}
            >
              {i18n.t("ShowMore")}
            </Alert.Link>
          </Row>
        </Container>
      </FullSection>

      <Footer />
    </>
  );
};

export default withTranslation()(MainPage);
